import { DeliveryClient } from "@kentico/kontent-delivery";

import faq from "./faq";
import document from "./document";
import promotion from "./promotion";

const projectId = "4f08dc2d-8529-01a3-689f-97b549716e32";

let language = "en";
let deliveryClient = null;

export const getDeliveryClient = () => {
  return deliveryClient;
};

export const setDeliveryClientDefaultLanguage = (defaultLanguage) => {
  language = defaultLanguage;
  updateDeliveryClient();
};

export const getKontentProjectId = () => {
  return projectId;
};

const updateDeliveryClient = () => {
  if (language === "en") {
    deliveryClient = new DeliveryClient({
      projectId: getKontentProjectId(),
    });
  } else {
    deliveryClient = new DeliveryClient({
      projectId: getKontentProjectId(),
      defaultLanguage: language,
    });
  }
};

updateDeliveryClient();

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  faq,
  document,
  promotion
};
